import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var HouseSvg = function HouseSvg(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27.29,11.4,17.2,1.9a2,2,0,0,0-2.4,0L4.71,11.4A2,2,0,0,0,4,12.93V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V12.93A2,2,0,0,0,27.29,11.4ZM20,28H12V20a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2Z"
  }));
};
HouseSvg.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(HouseSvg);